/* eslint-disable camelcase */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_start_7_day_free_trial__v2: Phrase = locale => {
  const en = `Start 7 Day Free Trial`;
  const phrases: { [key: string]: undefined | string } = {
    en,
    es: `7 días de prueba gratis.`,
  };
  return phrases[locale] || en;
};
